module.exports = __webpack_public_path__ + "img/109.2.4ec656a2.png";